import { render, staticRenderFns } from "./BlipArtistCategories.vue?vue&type=template&id=0cbcaf08&scoped=true&"
import script from "./BlipArtistCategories.vue?vue&type=script&lang=js&"
export * from "./BlipArtistCategories.vue?vue&type=script&lang=js&"
import style0 from "./BlipArtistCategories.vue?vue&type=style&index=0&id=0cbcaf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcaf08",
  null
  
)

export default component.exports